import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import moment from 'moment';

import MessageCollection from 'collections/message';
import AppointmentView from 'views/appointment';
import GoogleAnalytics from 'core/google_analytics';


export default Backbone.View.extend({
  events: {
    'keydown #message-form textarea': 'textarea_keydown',
    'submit #message-form': 'send_message',
  },


  initialize: function (options) {
    _.bindAll(this, 'add_message', 'render', 'textarea_keydown',
      'scroll_to_bottom', 'new_message', 'send_message',
      'change_message');

    this.template = _.template($('#coach-message-tmpl').html());
    this.coachhub = options.coachhub;
    this.recipient = options.user;

    this.message_list = $('.message-list', this.$el);
    this.message_form = $('#message-form', this.$el);
    this.message_input = $('textarea', this.message_form);
    this.meta_msg = $('#no-coach-msg');

    var data = $.param({ other: this.recipient.url }, true);
    this.collection = new MessageCollection();
    this.collection.fetch({ data: data, success: this.render });

    this.appointment_view = new AppointmentView({
      el: $('#appointment-modal'),
      msg_collection: this.collection
    });
    this.message_list.on('click', 'a.decline', this.appointment_view.decline_appointment);
    this.message_list.on('click', 'a.confirm', this.appointment_view.confirm_appointment);

  },

  add_message: function (message) {
    this.message_list.append(this.template({ message: message }));
    this.scroll_to_bottom();
  },

  scroll_to_bottom: function () {
    // Scroll to the bottom
    this.message_list.scrollTop(this.message_list[0].scrollHeight);
  },

  textarea_keydown: function (e) {
    // Send the message when the user presses the enter key (without shift)
    if (e.keyCode === 13 && !e.shiftKey) {
      e.preventDefault();
      this.message_form.submit();
    }
  },

  send_message: function (e) {
    e.preventDefault();
    var body = this.message_input.val();
    if (!body.length) {
      return;
    }
    this.message_input.val('');
    this.collection.create({
      recipient: this.recipient.url,
      body: body
    }, { wait: true });
    GoogleAnalytics.send_event('send-message-mh', 'create');
    this.meta_msg.addClass('hidden');
  },

  new_message: function (data) {
    var msg = data.message;
    var msg_ids = [ msg.author_id, msg.recipient_id ];
    var my_ids = [ this.coachhub.coachhub_user.get('id'), this.recipient.id ];
    // Make sure the message is from or to me and the current contact
    if (!_.difference(msg_ids, my_ids).length) {
      this.collection.add(msg);
    }
    this.meta_msg.addClass('hidden');
  },

  render: function () {

    this.collection.each(this.add_message);
    this.collection.on('add', this.add_message);
    this.collection.on('change:appointment', this.change_message);
    this.coachhub.on('new-message', this.new_message);
    if (this.collection.isEmpty()) {
      this.meta_msg.removeClass('hidden');
    }
  },

  change_message: function (msg) {
    var msg_el = $('#msg-' + msg.numerical_id());
    msg_el.replaceWith(this.template({ message: msg }));
  },
});



// WEBPACK FOOTER //
// ./static/js/views/coach_messages.js